const isDisabled = props => props.disabled || Array.isArray(props.accessibilityStates) && props.accessibilityStates.indexOf("disabled") > -1;
var isDisabled_default = isDisabled;
export { isDisabled_default as default };
//# sourceMappingURL=isDisabled.mjs.map
